import { normalCdf } from './normal';

/** P(k1 ≤ X ≤ k2) ≈ Φ((k2+½ − μ)/σ) − Φ((k1−½ − μ)/σ) with μ=np, σ²=np(1-p). */
export function binomialNormalCorrected(n: number, p: number, k1: number, k2: number): number {
  if (k1 > k2) return 0;
  const mu = n * p;
  const sigma = Math.sqrt(n * p * (1 - p));
  if (sigma === 0) return k1 <= mu && mu <= k2 ? 1 : 0;
  const upper = normalCdf(k2 + 0.5, mu, sigma);
  const lower = normalCdf(k1 - 0.5, mu, sigma);
  return Math.max(0, upper - lower);
}

export function continuityCorrectedRange(k: number): [number, number] {
  return [k - 0.5, k + 0.5];
}
